export default "__VITE_ASSET__BONSCyR1__"